import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { PATH_DASHBOARD } from 'routers/paths';
import { RoleRouter } from 'routers/RoleRouter';
import { ROLES } from 'config';

const Facility = lazy(() => import('pages/general/Facility'));
const NotValidatedClasses = lazy(() => import('pages/general/NotValidatedClasses'));
const LicensedProviders = lazy(() => import('pages/general/LicensedProviders'));
const Challenges = lazy(() => import('pages/general/Challenges'));
const RegisteredUsers = lazy(() => import('pages/general/RegisteredUsers'));
const Corporate = lazy(() => import('pages/general/Corporate'));
const PersonalTrainers = lazy(() => import('pages/general/PersonalTrainers'));
const OakleyEvents = lazy(() => import('pages/general/OakleyEvents'));

const NotFound = lazy(() => import('pages/Page404'));

export default function General() {
  return (
    <Routes>
      <Route
        index
        path={`${PATH_DASHBOARD.facility.root}/*`}
        element={
          <RoleRouter
            permittedRole={[ROLES.FACILITY_ADMIN, ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}
          >
            <Facility />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.notValidatedClasses.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <NotValidatedClasses />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.licensedProviders.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <LicensedProviders />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.challenges.root}/*`}
        element={
          <RoleRouter
            permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN, ROLES.CHALLENGE_ADMIN]}
          >
            <Challenges />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.corporate.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <Corporate />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.registeredUsers.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <RegisteredUsers />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.personalTrainers.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <PersonalTrainers />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.oakleyEvents.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <OakleyEvents />
          </RoleRouter>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
